import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListSubheader from '@material-ui/core/ListSubheader'
import ListingCard from './ListingCard'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  list: {},
  listHeader: {
    backgroundColor: theme.palette.grey[50],
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0,0,0,0.13)',
    borderTop: '1px solid rgba(0,0,0,0.13)',
  },
  listItem: {
    color: theme.palette.common.white,
    borderLeft: 'solid 4px transparent',
    borderBottom: 'solid 1px',
    borderBottomColor: theme.palette.grey[100],
    fill: theme.palette.common.white,
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main,
      borderLeft: `solid 4px ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.grey[50],
    },
  },
  mapContainer: {
    width: '100%',
    height: 400,
    margin: 0,
  },
})

class Locations extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { listings, onListingClick, classes } = this.props
    return listings && listings.length > 0 ? (
      <List className={classes.list}>
        <ListSubheader className={classes.listHeader} disableSticky>
          <span>Store Locator</span>
        </ListSubheader>
        {listings &&
          listings.map(listing => (
            <ListItem
              key={`${listing.id}-list-item`}
              className={classes.listItem}
            >
              <ListingCard listing={listing} onClick={onListingClick} />
            </ListItem>
          ))}
      </List>
    ) : (
      <div className={classes.noConnectionsContent}>
        <img
          src={require('../../static/images/categories/storefront.svg')} // eslint-disable-line
          style={{ height: 120, width: 120 }}
          alt="Retail"
        />
        <Typography variant="h6" className={classes.noConnectionsTitle}>
          This brand has no current locations.
        </Typography>
      </div>
    )
  }
}

Locations.propTypes = {}

export default withStyles(styles, { withTheme: true })(Locations)



// WEBPACK FOOTER //
// ./src/components/brands/Locations.js